import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface OrderParcelModel {
    parcel_id: string
    uuid: string
    new_awb_number: string
    purchase_order_number: string
    purchase_tracking_number?: string
    awb_link: string
    parcel_created_at: string
    parcel_updated_at: string
    parcel_status_id: number
    reason: string
    status_created_at: string
    recipient_name: string
    description: string
    quantity: number
}

export interface OrderModel {
    list_id: string
    file_name: string
    awb_status: number
    updated_at: string
    received_parcels: number
    parcels: OrderParcelModel[]
}

export interface ListQueries {
    warehouse: string
    page: number
    size: number
    keyword: string
}

const orderApi = (apiInstance: AxiosInstance) => {
    const ordersList = async ({
        warehouse,
        page,
        size,
        keyword = ""
    }: ListQueries): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/parcels-lists-all?page=${page}&size=${size}&warehouse_id=${warehouse}&keyword=${keyword}`
        )
        return res
    }

    return {
        ordersList
    }
}

export default orderApi
